import newsService from '../services/newsService';

export const fetchAllNews = async (params) => {
  const result = await newsService.getAllNews(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Haberler alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const createNews = async (payload) => {
  const result = await newsService.createNews(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Haber oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createNewsWithGallery = async ({ dto, galleryImages }) => {
  const result = await newsService.createNewsWithGallery({ dto, galleryImages });
  if (!result?.success) {
    const error = new Error(result?.message || 'Haber oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const uploadNewsImage = async ({ newsId, file }) => {
  const result = await newsService.uploadNewsImage({ newsId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'Görsel yüklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const uploadNewsImages = async ({ newsId, files }) => {
  const result = await newsService.uploadNewsImages({ newsId, files });
  if (!result?.success) {
    const error = new Error(result?.message || 'Görseller yüklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteNews = async (id) => {
  const result = await newsService.deleteNews(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Haber silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchNewsById = async (id) => {
  const result = await newsService.getNewsById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Haber alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderNewsImages = async ({ newsId, imageIdsInOrder }) => {
  const result = await newsService.reorderNewsImages({ newsId, imageIdsInOrder });
  if (!result?.success) {
    const error = new Error(result?.message || 'Görseller sıralanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeNewsImage = async ({ newsId, imageId }) => {
  const result = await newsService.removeNewsImage({ newsId, imageId });
  if (!result?.success) {
    const error = new Error(result?.message || 'Görsel kaldırılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateNews = async (payload) => {
  const result = await newsService.updateNews(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Haber güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllNews,
  createNews,
  uploadNewsImage,
  uploadNewsImages,
  deleteNews,
  fetchNewsById,
  reorderNewsImages,
  removeNewsImage,
  updateNews,
};


